import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { SelectOption } from '@minecraft.typings';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { useTranslation } from '@blocs.i18n';
import { BasicFormItem } from '../../shared/styles';
import { FiltersNameEnum } from '../../shared/types';

interface TalentTypeProps {
  includeLuminate?: boolean;
  unrepresentedLabel?: string;
  representedLabel?: string;
  luminateLabel?: string;
}

const TalentType: FC<TalentTypeProps> = ({
  includeLuminate = false,
  unrepresentedLabel,
  representedLabel,
  luminateLabel,
}) => {
  const { t } = useTranslation();
  const { values, setValues } = useFormikContext<any>();
  const talentTypeOptions = [
    {
      value: FiltersNameEnum.unrepresented,
      label: unrepresentedLabel || t('common:filtersName.unrepresented'),
    },
    {
      value: FiltersNameEnum.represented,
      label: representedLabel || t('common:filtersName.represented'),
    },
  ].concat(
    includeLuminate
      ? [
          {
            value: FiltersNameEnum.luminate,
            label: luminateLabel || t('common:filtersName.luminate'),
          },
        ]
      : []
  );

  const onRepTypeChange = (options: SelectOption[]) => {
    setValues({
      ...values,
      [FiltersNameEnum.talentType]: options,
    });
  };
  const initialRepTypes = values[FiltersNameEnum.talentType];

  return (
    <BasicFormItem>
      <DropdownWithChildren
        isMultipleSelect
        toggleLabel={t('common:filtersName.talentType')}
        options={talentTypeOptions}
        initialSelectedOptions={initialRepTypes}
        onOptionsChange={onRepTypeChange}
      />
    </BasicFormItem>
  );
};

export { TalentType };
